import React from 'react';
import PropTypes from 'prop-types';

const wrapperStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '0.5rem',
  marginTop: '0.25rem',
  padding: '0.75rem 1rem',
  backgroundColor: '#FFF2F4',
  border: '1px solid #D81A35',
  borderLeft: '4px solid #D81A35',
  borderRadius: '0.25rem',
  maxWidth: '100%',
  boxSizing: 'border-box',
};

const iconStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '1.25rem',
  height: '1.25rem',
  minWidth: '1.25rem',
  borderRadius: '50%',
  background: '#D81A35',
  color: '#fff',
  fontSize: '0.75rem',
  fontWeight: '700',
  flexShrink: 0,
};

const textStyle = {
  color: '#2A2C2E',
  fontSize: '0.875rem',
  lineHeight: '1.4',
  wordBreak: 'break-word',
};

const Error = ({ text }) => (
  <div style={{ marginTop: '0.25rem' }}>
    <span style={wrapperStyle}>
      <span style={iconStyle} aria-hidden="true">!</span>
      <span style={textStyle}>{text}</span>
    </span>
  </div>
);

Error.propTypes = {
  text: PropTypes.string.isRequired
};

export default Error;
